import Vue from 'vue'
import '@/i18n/index'

const { i18n } = Vue

export const categories = [
  {
    value: 'REFUND',
    name: i18n.translate('movement.category.REFUND'),
  },
  {
    value: 'RECHARGE',
    name: i18n.translate('movement.category.RECHARGE'),
  },
  {
    value: 'TERMINATION',
    name: i18n.translate(`movement.category.TERMINATION`),
  },
  {
    value: 'TRANSFER',
    name: i18n.translate(`movement.category.TRANSFER`),
  },
  {
    value: 'CHARGE',
    name: i18n.translate(`movement.category.CHARGE`),
  },
  {
    value: 'RENT_OUT',
    name: i18n.translate(`movement.category.RENT_OUT`),
  },
  {
    value: 'POST_PAID',
    name: i18n.translate(`movement.category.POST_PAID`),
  },
  {
    value: 'EXPENDITURE',
    name: i18n.translate(`movement.category.EXPENDITURE`),
  },
];

export const reasonsByCategory = {
  'REFUND': [
    { value: 'DAMAGES_AND_LOSSES', name: i18n.translate('movement.reason.DAMAGES_AND_LOSSES') },
    { value: 'MISSING_ACCEPTANCE', name: i18n.translate('movement.reason.MISSING_ACCEPTANCE') },
    { value: 'APPOINTMENT_NOT_DONE', name: i18n.translate('movement.reason.APPOINTMENT_NOT_DONE') },
  ],
  'RECHARGE': [
    { value: 'CREDIT_ADVANCE', name: i18n.translate('movement.reason.CREDIT_ADVANCE') },
    { value: 'CREDIT_CORRECTION', name: i18n.translate('movement.reason.CREDIT_CORRECTION') },
    { value: 'CREDIT_ADDITION', name: i18n.translate('movement.reason.CREDIT_ADDITION') }
  ],
  'TERMINATION': [
    { value: 'CONTRACTUAL_PENALTY', name: i18n.translate('movement.reason.CONTRACTUAL_PENALTY') },
    { value: 'EXPIRED_BALANCE', name: i18n.translate('movement.reason.EXPIRED_BALANCE') }
  ],
  'TRANSFER': [
    { value: 'BALANCE_TRANSFER_BETWEEN_ACCOUNTS', name: i18n.translate('movement.reason.BALANCE_TRANSFER_BETWEEN_ACCOUNTS') }
  ],
  'CHARGE': [
    { value: 'EXPIRED_CHARGE', name: i18n.translate('movement.reason.EXPIRED_CHARGE') },
    { value: 'RECEIVED_CHARGE', name: i18n.translate('movement.reason.RECEIVED_CHARGE') },
    { value: 'PLATFORM_FEE', name: i18n.translate('movement.reason.PLATFORM_FEE') },
    { value: 'SAAS_SUBSCRIPTION', name: i18n.translate('movement.reason.SAAS_SUBSCRIPTION') }
  ],
  'RENT_OUT': [
    { value: 'COMISSION_PAYMENT', name: i18n.translate('movement.reason.COMISSION_PAYMENT') },
    { value: 'FCI_PAYMENT', name: i18n.translate('movement.reason.FCI_PAYMENT') }
  ],
  'POST_PAID': [
    { value: 'CREDIT_ADVANCE', name: i18n.translate('movement.reason.CREDIT_ADVANCE') }
  ],
  'EXPENDITURE': [
    { value: 'APPOINTMENT_DONE', name: i18n.translate('movement.reason.APPOINTMENT_DONE') },
    { value: 'RECALCULATION', name: i18n.translate('movement.reason.RECALCULATION') },
    { value: 'BALANCE_PAYMENT', name: i18n.translate('movement.reason.BALANCE_PAYMENT') },
  ],
  'EVICTION': [
    { value: 'BALANCE_PAYMENT', name: i18n.translate('movement.reason.BALANCE_PAYMENT') },
  ]
};

export const customMovementReasons = [
  { value: 'APPOINTMENT_NOT_DONE', name: i18n.translate('movement.reason.APPOINTMENT_NOT_DONE') },
]